// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-checkbox-style-1,
.custom-radio-style-1 {
  position: relative;
  padding: 0;
}
.custom-checkbox-style-1 .custom-control-input,
.custom-radio-style-1 .custom-control-input {
  display: none;
}
.custom-checkbox-style-1 .custom-control-label,
.custom-radio-style-1 .custom-control-label {
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #212529 !important;
  margin-bottom: 0 !important;
  font-weight: 500 !important;
  padding-left: 32px;
  position: relative;
}
.custom-checkbox-style-1 .custom-control-label::before,
.custom-radio-style-1 .custom-control-label::before {
  width: 20px;
  height: 20px;
  border: 2px solid #2755fe;
  border-radius: 2px;
  top: 0;
  left: 0;
  box-shadow: none !important;
  content: "";
  display: inline-block;
  position: absolute;
}
.custom-checkbox-style-1 .custom-control-label::after,
.custom-radio-style-1 .custom-control-label::after {
  width: 20px;
  height: 20px;
  top: 0;
  left: 0;
  border-radius: 2px;
  content: "";
  display: inline-block;
  position: absolute;
}
.custom-checkbox-style-1 .custom-control-input:checked ~ .custom-control-label::before,
.custom-radio-style-1 .custom-control-input:checked ~ .custom-control-label::before {
  border-color: #2755fe;
  background: #fff;
  box-shadow: none;
}
.custom-checkbox-style-1 .custom-control-input:checked ~ .custom-control-label::after,
.custom-radio-style-1 .custom-control-input:checked ~ .custom-control-label::after {
  background: #2755fe;
  background-image: url(https://portal.in.springverify.com/dbb37f90df47cc9b0e5b.svg);
  background-position: center center;
  background-size: 80%;
  background-repeat: no-repeat;
}
.custom-checkbox-style-1 .custom-control-input:disabled ~ .custom-control-label,
.custom-radio-style-1 .custom-control-input:disabled ~ .custom-control-label {
  opacity: 0.6;
}
.custom-checkbox-style-1 .custom-control-input:disabled ~ .custom-control-label::before,
.custom-radio-style-1 .custom-control-input:disabled ~ .custom-control-label::before {
  opacity: 0.6;
  border-color: #666666;
}
.custom-checkbox-style-1 .custom-control-input:disabled ~ .custom-control-label::after,
.custom-radio-style-1 .custom-control-input:disabled ~ .custom-control-label::after {
  opacity: 0.6;
}
.custom-checkbox-style-1 .custom-control-input:checked:disabled ~ .custom-control-label,
.custom-radio-style-1 .custom-control-input:checked:disabled ~ .custom-control-label {
  opacity: 0.6;
}
.custom-checkbox-style-1 .custom-control-input:checked:disabled ~ .custom-control-label::before,
.custom-radio-style-1 .custom-control-input:checked:disabled ~ .custom-control-label::before {
  opacity: 0.6;
  border-color: #666666;
}
.custom-checkbox-style-1 .custom-control-input:checked:disabled ~ .custom-control-label::after,
.custom-radio-style-1 .custom-control-input:checked:disabled ~ .custom-control-label::after {
  opacity: 0.6;
  background-color: #666666;
}

.custom-radio-style-1 .custom-control-label {
  cursor: pointer;
  margin-bottom: 0 !important;
}
.custom-radio-style-1 .custom-control-label::before {
  border-radius: 100%;
}
.custom-radio-style-1 .custom-control-input:checked ~ .custom-control-label::before {
  border-color: #2755fe;
  background: #fff;
}
.custom-radio-style-1 .custom-control-input:checked ~ .custom-control-label::after {
  width: 10px;
  height: 10px;
  background: #2755fe;
  border-radius: 100%;
  left: 5px;
  top: 5px;
}
.custom-radio-style-1 .custom-control-input:disabled ~ .custom-control-label {
  opacity: 0.6;
}
.custom-radio-style-1 .custom-control-input:disabled ~ .custom-control-label::before {
  opacity: 0.6;
  border-color: #666666;
}
.custom-radio-style-1 .custom-control-input:disabled ~ .custom-control-label::after {
  opacity: 0.6;
}
.custom-radio-style-1 .custom-control-input:checked:disabled ~ .custom-control-label {
  opacity: 0.6;
}
.custom-radio-style-1 .custom-control-input:checked:disabled ~ .custom-control-label::before {
  opacity: 0.6;
  border-color: #666666;
  background-color: transparent;
}
.custom-radio-style-1 .custom-control-input:checked:disabled ~ .custom-control-label::after {
  opacity: 0.6;
  background: #666666;
}

.custom-checkbox-style {
  position: relative;
  padding: 0;
}
.custom-checkbox-style .custom-control-label {
  cursor: pointer;
  color: #333333 !important;
  font-size: 14px !important;
  font-family: Poppins !important;
  font-weight: 400 !important;
  line-height: 21px !important;
  word-wrap: break-word !important;
  padding-left: 20px !important;
}
.custom-checkbox-style .custom-control-label::before {
  width: 16px;
  height: 16px;
  border: 2px solid #2755fe;
  border-radius: 2px;
  top: 2px;
  left: 0;
  box-shadow: none !important;
}
.custom-checkbox-style .custom-control-label::after {
  width: 16px;
  height: 16px;
  top: 2px;
  left: 0;
  border-radius: 2px;
}
.custom-checkbox-style .custom-control-input {
  display: none;
}
.custom-checkbox-style .custom-control-input:checked ~ .custom-control-label::before {
  border-color: #2755fe;
  background: #fff;
  box-shadow: none;
}
.custom-checkbox-style .custom-control-input:checked ~ .custom-control-label::after {
  background: #2755fe;
  background-image: url(https://portal.in.springverify.com/dbb37f90df47cc9b0e5b.svg);
  background-position: center center;
  background-size: 80%;
  background-repeat: no-repeat;
}
.custom-checkbox-style .custom-control-input:disabled ~ .custom-control-label {
  opacity: 0.6;
}
.custom-checkbox-style .custom-control-input:disabled ~ .custom-control-label::before {
  opacity: 0.6;
  border-color: #666666;
}
.custom-checkbox-style .custom-control-input:disabled ~ .custom-control-label::after {
  opacity: 0.6;
}
.custom-checkbox-style .custom-control-input:checked:disabled ~ .custom-control-label {
  opacity: 0.6;
}
.custom-checkbox-style .custom-control-input:checked:disabled ~ .custom-control-label::before {
  opacity: 0.6;
  border-color: #666666;
}
.custom-checkbox-style .custom-control-input:checked:disabled ~ .custom-control-label::after {
  opacity: 0.6;
  background-color: #666666;
}`, "",{"version":3,"sources":["webpack://./src/components/CompanyAdmin/frontend-common/Settings/AlumniVerification/custom-checkbox.scss"],"names":[],"mappings":"AAAA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,2BAA2B;EAC3B,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;AACA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;EACnB,kFAAkF;EAClF,kCAAkC;EAClC,oBAAoB;EACpB,4BAA4B;AAC9B;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,YAAY;EACZ,qBAAqB;AACvB;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,YAAY;EACZ,qBAAqB;AACvB;AACA;;EAEE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,QAAQ;AACV;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,qBAAqB;EACrB,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,0BAA0B;EAC1B,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,gCAAgC;EAChC,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,OAAO;EACP,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,kFAAkF;EAClF,kCAAkC;EAClC,oBAAoB;EACpB,4BAA4B;AAC9B;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B","sourcesContent":[".custom-checkbox-style-1,\n.custom-radio-style-1 {\n  position: relative;\n  padding: 0;\n}\n.custom-checkbox-style-1 .custom-control-input,\n.custom-radio-style-1 .custom-control-input {\n  display: none;\n}\n.custom-checkbox-style-1 .custom-control-label,\n.custom-radio-style-1 .custom-control-label {\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #212529 !important;\n  margin-bottom: 0 !important;\n  font-weight: 500 !important;\n  padding-left: 32px;\n  position: relative;\n}\n.custom-checkbox-style-1 .custom-control-label::before,\n.custom-radio-style-1 .custom-control-label::before {\n  width: 20px;\n  height: 20px;\n  border: 2px solid #2755fe;\n  border-radius: 2px;\n  top: 0;\n  left: 0;\n  box-shadow: none !important;\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n}\n.custom-checkbox-style-1 .custom-control-label::after,\n.custom-radio-style-1 .custom-control-label::after {\n  width: 20px;\n  height: 20px;\n  top: 0;\n  left: 0;\n  border-radius: 2px;\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n}\n.custom-checkbox-style-1 .custom-control-input:checked ~ .custom-control-label::before,\n.custom-radio-style-1 .custom-control-input:checked ~ .custom-control-label::before {\n  border-color: #2755fe;\n  background: #fff;\n  box-shadow: none;\n}\n.custom-checkbox-style-1 .custom-control-input:checked ~ .custom-control-label::after,\n.custom-radio-style-1 .custom-control-input:checked ~ .custom-control-label::after {\n  background: #2755fe;\n  background-image: url(https://portal.in.springverify.com/dbb37f90df47cc9b0e5b.svg);\n  background-position: center center;\n  background-size: 80%;\n  background-repeat: no-repeat;\n}\n.custom-checkbox-style-1 .custom-control-input:disabled ~ .custom-control-label,\n.custom-radio-style-1 .custom-control-input:disabled ~ .custom-control-label {\n  opacity: 0.6;\n}\n.custom-checkbox-style-1 .custom-control-input:disabled ~ .custom-control-label::before,\n.custom-radio-style-1 .custom-control-input:disabled ~ .custom-control-label::before {\n  opacity: 0.6;\n  border-color: #666666;\n}\n.custom-checkbox-style-1 .custom-control-input:disabled ~ .custom-control-label::after,\n.custom-radio-style-1 .custom-control-input:disabled ~ .custom-control-label::after {\n  opacity: 0.6;\n}\n.custom-checkbox-style-1 .custom-control-input:checked:disabled ~ .custom-control-label,\n.custom-radio-style-1 .custom-control-input:checked:disabled ~ .custom-control-label {\n  opacity: 0.6;\n}\n.custom-checkbox-style-1 .custom-control-input:checked:disabled ~ .custom-control-label::before,\n.custom-radio-style-1 .custom-control-input:checked:disabled ~ .custom-control-label::before {\n  opacity: 0.6;\n  border-color: #666666;\n}\n.custom-checkbox-style-1 .custom-control-input:checked:disabled ~ .custom-control-label::after,\n.custom-radio-style-1 .custom-control-input:checked:disabled ~ .custom-control-label::after {\n  opacity: 0.6;\n  background-color: #666666;\n}\n\n.custom-radio-style-1 .custom-control-label {\n  cursor: pointer;\n  margin-bottom: 0 !important;\n}\n.custom-radio-style-1 .custom-control-label::before {\n  border-radius: 100%;\n}\n.custom-radio-style-1 .custom-control-input:checked ~ .custom-control-label::before {\n  border-color: #2755fe;\n  background: #fff;\n}\n.custom-radio-style-1 .custom-control-input:checked ~ .custom-control-label::after {\n  width: 10px;\n  height: 10px;\n  background: #2755fe;\n  border-radius: 100%;\n  left: 5px;\n  top: 5px;\n}\n.custom-radio-style-1 .custom-control-input:disabled ~ .custom-control-label {\n  opacity: 0.6;\n}\n.custom-radio-style-1 .custom-control-input:disabled ~ .custom-control-label::before {\n  opacity: 0.6;\n  border-color: #666666;\n}\n.custom-radio-style-1 .custom-control-input:disabled ~ .custom-control-label::after {\n  opacity: 0.6;\n}\n.custom-radio-style-1 .custom-control-input:checked:disabled ~ .custom-control-label {\n  opacity: 0.6;\n}\n.custom-radio-style-1 .custom-control-input:checked:disabled ~ .custom-control-label::before {\n  opacity: 0.6;\n  border-color: #666666;\n  background-color: transparent;\n}\n.custom-radio-style-1 .custom-control-input:checked:disabled ~ .custom-control-label::after {\n  opacity: 0.6;\n  background: #666666;\n}\n\n.custom-checkbox-style {\n  position: relative;\n  padding: 0;\n}\n.custom-checkbox-style .custom-control-label {\n  cursor: pointer;\n  color: #333333 !important;\n  font-size: 14px !important;\n  font-family: Poppins !important;\n  font-weight: 400 !important;\n  line-height: 21px !important;\n  word-wrap: break-word !important;\n  padding-left: 20px !important;\n}\n.custom-checkbox-style .custom-control-label::before {\n  width: 16px;\n  height: 16px;\n  border: 2px solid #2755fe;\n  border-radius: 2px;\n  top: 2px;\n  left: 0;\n  box-shadow: none !important;\n}\n.custom-checkbox-style .custom-control-label::after {\n  width: 16px;\n  height: 16px;\n  top: 2px;\n  left: 0;\n  border-radius: 2px;\n}\n.custom-checkbox-style .custom-control-input {\n  display: none;\n}\n.custom-checkbox-style .custom-control-input:checked ~ .custom-control-label::before {\n  border-color: #2755fe;\n  background: #fff;\n  box-shadow: none;\n}\n.custom-checkbox-style .custom-control-input:checked ~ .custom-control-label::after {\n  background: #2755fe;\n  background-image: url(https://portal.in.springverify.com/dbb37f90df47cc9b0e5b.svg);\n  background-position: center center;\n  background-size: 80%;\n  background-repeat: no-repeat;\n}\n.custom-checkbox-style .custom-control-input:disabled ~ .custom-control-label {\n  opacity: 0.6;\n}\n.custom-checkbox-style .custom-control-input:disabled ~ .custom-control-label::before {\n  opacity: 0.6;\n  border-color: #666666;\n}\n.custom-checkbox-style .custom-control-input:disabled ~ .custom-control-label::after {\n  opacity: 0.6;\n}\n.custom-checkbox-style .custom-control-input:checked:disabled ~ .custom-control-label {\n  opacity: 0.6;\n}\n.custom-checkbox-style .custom-control-input:checked:disabled ~ .custom-control-label::before {\n  opacity: 0.6;\n  border-color: #666666;\n}\n.custom-checkbox-style .custom-control-input:checked:disabled ~ .custom-control-label::after {\n  opacity: 0.6;\n  background-color: #666666;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
